import { icon, iconBadge, iconPlain } from '../lib/icons';
import { fmt } from '../lib/format';
import { state, categoryName, categoryIconKey } from '../state';
import type { Expense } from '../types';

export function renderAddButton(): string {
  return `<button class="btn btn-primary btn-sm add-btn" onclick="App.openAddExpenseSheet()">${icon(
    'plus',
    15
  )} Add</button>`;
}

export function renderOfflineBanner(): string {
  if (state.online) return '';
  return `<div class="offline-banner"><span class="dot"></span> Offline — showing data saved on this device</div>`;
}

export function renderNav(): string {
  const items: Array<{ id: typeof state.activeTab; ic: string; lbl: string }> = [
    { id: 'dashboard', ic: 'home', lbl: 'Home' },
    { id: 'expenses', ic: 'list', lbl: 'Expenses' },
    { id: 'map', ic: 'map', lbl: 'Map' },
    { id: 'reports', ic: 'chart', lbl: 'Reports' },
    { id: 'settings', ic: 'settings', lbl: 'Settings' },
  ];
  return `<nav class="navbar" aria-label="Primary">${items
    .map(
      (it) => `
    <button class="nav-item ${state.activeTab === it.id ? 'active' : ''}" aria-current="${
        state.activeTab === it.id ? 'page' : 'false'
      }" onclick="App.setTab('${it.id}')">
      <span class="nav-ic-wrap">${icon(it.ic, 20)}</span><span class="lbl">${it.lbl}</span>
    </button>`
    )
    .join('')}</nav>`;
}

export function expenseRow(e: Expense): string {
  const cat = categoryName(e.categoryId);
  return `<button class="exp-item" onclick="App.openExpenseDetail('${e.id}')">
    ${iconBadge(categoryIconKey(e.categoryId), { size: 'icon-badge-md', iconSize: 18 })}
    <div class="exp-mid">
      <div class="exp-cat">${escapeHtml(cat)}</div>
      <div class="exp-sub">${e.explanation ? escapeHtml(e.explanation) : e.date}</div>
    </div>
    <div class="exp-amt">
      <div class="n">${fmt(e.amount, e.currency)}</div>
      <div class="d">${e.date}</div>
    </div>
  </button>`;
}

export function emptyState(ic: string, title: string, sub: string, actionHtml = ''): string {
  return `<div class="empty">${iconBadge(ic, { size: 'icon-badge-lg', iconSize: 24 })}<h3>${title}</h3><p>${sub}</p>${actionHtml}</div>`;
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}

export { iconPlain };
